import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ICartFeature } from './cart.feature.state';
import { CartState } from './cart.state';

export const getCartState: MemoizedSelector<ICartFeature, CartState> = createFeatureSelector<CartState>(
  nameof<ICartFeature>('CartFeature')
);

export const getIsLoading = createSelector(getCartState, (state: CartState) => state.isLoading);
export const getFailures = createSelector(getCartState, (state: CartState) => state.failures);
export const getCart = createSelector(getCartState, (state: CartState) => state.cart);
export const getSubTotal = createSelector(getCartState, (state: CartState) => state.subTotal);
export const getCartUnAvailabilItems = createSelector(getCartState, (state: CartState) => state.cartUnAvailabilItems);
export const getAccountId = createSelector(getCartState, (state: CartState) => state.accountID);
export const getCartStartTime = createSelector(getCartState, (state: CartState) => state.cartStartTime);
